<template>
  <Head :title="__('how-does-it-work.meta.title')">
    <meta
      name="description"
      :content="__('how-does-it-work.meta.description')"
    >
    <link
      rel="canonical"
      :href="localeRoute('frontend.how-does-it-work')"
    >
    <meta
      property="og:image"
      content="/frontend/assets/favicon/og-image.jpg"
    >
  </Head>

  <section class="how-does-it-work-hero py-20 relative overflow-hidden">
    <img
      src="/frontend/assets/mobile-hero-swirl.svg"
      class="absolute top-0 left-0 lg:hidden"
    >
    <img
      src="/frontend/assets/desktop-hero-swirl.svg"
      class="absolute top-0 left-0 hidden lg:block"
    >

    <div class="container">
      <div class="text-center px-8">
        <h1 class="text-5xl font-bold lg:text-7xl">
          {{ __('how-does-it-work.title') }}
        </h1>

        <p class="text-gray-400 mt-2 lg:text-xl mb-0 lg:w-3/5 lg:mx-auto">
          {{ __('how-does-it-work.text') }}
        </p>
      </div>
    </div>
  </section>

  <HowDoesItWork />

  <Reviews
    title="Wat zeggen anderen over ShoutOut.vip"
    class="pt-24 lg:pb-10"
  />

  <section class="cta-small bg-red py-16 text-center lg:text-left">
    <div class="container">
      <div class="lg:flex lg:flex-wrap lg:items-center">
        <h2 class="text-4xl text-white font-bold w-full lg:w-4/5">
          {{ __('how-does-it-work.footer.text') }}
        </h2>

        <Link
          :href="localeRoute('frontend.index')"
          class="button-white shadow-button-black inline-block mt-8 mx-0 lg:mx-auto w-full md:w-auto lg:w-1/5 lg:mt-0"
        >
          {{ __('general.see-all-vips') }}
        </Link>
      </div>
    </div>
  </section>
</template>

<script>
import Reviews from '../../Components/Reviews.vue';
import HowDoesItWork from '../../Components/HowDoesItWork.vue';

export default {
  components: {
    Reviews,
    HowDoesItWork,
  },
};
</script>
